import React from "react";
import Icon from "components/AppIcon";

export default function UsersAccessPage() {
  return (
    <div className="px-4 py-4 md:px-6 md:py-6">
      <main className="mx-auto max-w-6xl space-y-6">
        <section className="rounded-xl border border-border bg-card p-5 shadow-sm md:p-6">
          <div className="flex items-start gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-primary/15 bg-primary/10 text-primary">
              <Icon name="ShieldCheck" className="h-5 w-5" />
            </div>
            <div className="min-w-0">
              <p className="text-xs font-semibold uppercase tracking-[0.14em] text-muted-foreground">
                Administration
              </p>
              <h1 className="mt-1 text-2xl font-bold text-foreground md:text-3xl">
                Users & Access
              </h1>
              <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
                User permissions, roles, module access, and org unit oversight will be managed here.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
